import { useCallback } from 'react';

import { useChartContext } from '@/components/Chart/context/ChartContext';
import useDateText, { DateTextVariants } from '@/components/DateText/useDateText';

import type { ExportingMimeTypeValue } from 'highcharts';

const useChartImageExport = () => {
  const { formatDateString } = useDateText();
  const { chartRef } = useChartContext();

  const getDateSuffix = useCallback(() => {
    const date = formatDateString(new Date().toJSON(), DateTextVariants.WITH_TIME);
    return date.split(' ').join('T');
  }, [formatDateString]);

  const onExport = useCallback(
    (type: ExportingMimeTypeValue) => {
      if (chartRef.current?.chart) {
        chartRef.current.chart.exportChart(
          { type, filename: `GX-Chart-${getDateSuffix()}` },
          {
            ...(chartRef.current.chart.options.exporting?.chartOptions ??
              chartRef.current.chart.options),
            // Pass export type so exportEvents.load() can branch on it
            exporting: { type }
          }
        );
      }
    },
    [chartRef, getDateSuffix]
  );

  return { onExport };
};

export default useChartImageExport;
